import React from "react";
import "../styles/tableMenu.scss";
export default function TableMenu({ children, style, className }) {
  return (
    <div className={`table-menu ${className}`} style={{ ...style }}>
      {children}
    </div>
  );
}
